module.exports = __webpack_public_path__ + "static/antibody-4eb8b6325436cf9955c9ba9eeb745133.gif";